import {
  Box,
  Flex,
  Icon,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import moment from "moment-timezone";
import { Icons } from "../../WinterCountIconFIle";

const RecentAssignmentTable = ({
  data,
  handleNavigation,
  isLoading,
  fetchMoreAssignments,
  errorAssignments,
}) => {
  return (
    <Box>
      <TableContainer maxH="55vh" overflowY="auto">
        <Table size="sm" variant="striped">
          <Thead>
            <Tr>
              {["Name", "Date", "Case", "Open"].map((label) => (
                <Th
                  key={label}
                  position="sticky"
                  top={0}
                  bg="white"
                  zIndex={1}
                  py={3}
                  px={5}
                  fontSize="xs"
                  fontWeight="600"
                  letterSpacing="0.06em"
                  textTransform="uppercase"
                  color="gray.400"
                  borderBottomWidth="1px"
                  borderColor="gray.100"
                >
                  {label}
                </Th>
              ))}
            </Tr>
          </Thead>

          <Tbody>
            {isLoading &&
              Array.from({ length: 6 }).map((_, idx) => (
                <Tr key={idx}>
                  {Array.from({ length: 4 }).map((_, i) => (
                    <Td key={i} px={5} py={3}>
                      <Skeleton height="14px" borderRadius="md" />
                    </Td>
                  ))}
                </Tr>
              ))}

            {!isLoading &&
              data?.length > 0 &&
              data.map((item, idx) => (
                <Tr
                  key={idx}
                  cursor="pointer"
                  onClick={() => handleNavigation(item)}
                  _hover={{ bg: "blue.100" }}
                  transition="background 0.15s ease"
                  borderBottomWidth="1px"
                  borderColor="gray.50"
                >
                  <Td px={5} py={3}>
                    <Text fontSize="sm" fontWeight="500" color="gray.700">
                      {`${item.FIRST_NAME} ${item.LAST_NAME}`}
                    </Text>
                  </Td>
                  <Td px={5} py={3}>
                    <Text fontSize="sm" color="gray.500">
                      {moment(item?.EVENT_DATE, "YYYYMMDD").format(
                        "YYYY-MM-DD",
                      ) || "—"}
                    </Text>
                  </Td>
                  <Td px={5} py={3}>
                    <Box
                      display="inline-block"
                      px={2}
                      py={0.5}
                      bg="blue.50"
                      color="blue.600"
                      borderRadius="md"
                      fontSize="xs"
                      fontWeight="500"
                    >
                      {item.PRODUCT}
                    </Box>
                  </Td>
                  <Td px={5} py={3} isNumeric>
                    <Icon
                      as={Icons.OpenExternalLinkIcon}
                      boxSize={4}
                      color="gray.400"
                      _hover={{ color: "blue.500" }}
                      transition="color 0.15s"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNavigation(item);
                      }}
                    />
                  </Td>
                </Tr>
              ))}

            {!isLoading && !data?.length && (
              <Tr>
                <Td colSpan={4} px={5} py={10} textAlign="center">
                  <Text fontSize="sm" color="gray.400">
                    No assigned cases found
                  </Text>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>

      {errorAssignments && (
        <Flex justify="center" py={4}>
          <Text fontSize="sm" color="red.400">
            Failed to load active assignments
          </Text>
        </Flex>
      )}

      {/* <Box borderTopWidth="1px" borderColor="gray.100" px={5} py={3}>
        <Button
          onClick={fetchMoreAssignments}
          isDisabled={isLoading}
          size="xs"
          w="100%"
          variant="ghost"
          color="gray.500"
          fontWeight="500"
          borderRadius="lg"
          _hover={{ bg: "gray.50", color: "gray.700" }}
        >
          Load more
        </Button>
      </Box> */}
    </Box>
  );
};

export default RecentAssignmentTable;
